import Translation from './index'
import { Lang } from '../types'
import SpanishTranslation from './SpanishTranslation'
import EnglishTranslation from './EnglishTranslation'

export default class TranslationFactory {
  public static getTranslation(lang: Lang): Translation {
    switch (lang) {
      case 'es':
        return new SpanishTranslation()
      case 'en':
        return new EnglishTranslation()
    }
  }
}
